import React, { useEffect, useState, useCallback } from "react";
import { registerSW } from "virtual:pwa-register";
import mixpanel from "mixpanel-browser";

import Button from "components/Button";

import classes from "./styles.module.scss";

export default function UpdatePrompt() {
    const [needRefresh, setNeedRefresh] = useState(false);
    const [offlineReady, setOfflineReady] = useState(false);
    const [closing, setClosing] = useState(false);
    const [update, setUpdate] = useState(() => () => {});

    const close = useCallback(() => {
        // console.log("[PWA] User clicked Not now / closing toast.");

        setClosing(true);

        mixpanel.track("User got update prompt, and didn't refresh page.");

        setTimeout(() => {
            setClosing(false);
            setNeedRefresh(false);
            setOfflineReady(false);
        }, 300);
    }, []);

    useEffect(() => {
        // console.log("[PWA] Registering service worker...");

        const updateSW = registerSW({
            onNeedRefresh() {
                // console.log("[PWA] A new version is available.");
                setNeedRefresh(true);
            },
            onOfflineReady() {
                // console.log("[PWA] App is ready to work offline.");
                // setOfflineReady(true);
                // setTimeout(() => {
                //     console.log("[PWA] Hiding offline-ready message after timeout.");
                //     close();
                // }, 2500);
            },
        });

        // console.log("[PWA] Service worker registered.");
        setUpdate(() => updateSW);
    }, [close]);

    // ESC to dismiss
    useEffect(() => {
        if (!needRefresh && !offlineReady) return;
        const onKey = (e) => e.key === "Escape" && close();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [needRefresh, offlineReady, close]);

    // nothing to show
    if (!needRefresh && !offlineReady) return null;

    return (
        <div
            className={[classes.pwaToast, closing ? classes.exit : classes.enter].join(" ")}
            role="status"
            aria-live="polite"
        >
            <div className={classes.pwaCard}>
                {needRefresh && (
                    <>
                        <div className={classes.pwaTitle}>A new version of this page is available</div>
                        <div className={classes.pwaSub}>Refresh to see the latest changes.</div>
                        <div className={classes.pwaActions}>
                            <Button className={classes.pwaBtn} onClick={close}>
                                Not now
                            </Button>
                            <Button
                                className={`${classes.pwaBtn} ${classes.pwaPrimary}`}
                                onClick={() => {
                                    // console.log("[PWA] User clicked Refresh. Activating new SW...");
                                    mixpanel.track("User got update prompt, and refreshed page.");
                                    setClosing(true);
                                    update(true);
                                }}
                            >
                                Refresh
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
